import r from "./ghl-ui.es713.js";
import e from "./ghl-ui.es714.js";
import o from "./ghl-ui.es637.js";
var a = 1 / 0, n = r && 1 / o(new r([, -0]))[1] == a ? function(t) {
  return new r(t);
} : e;
const c = n;
export {
  c as default
};
